import React, { useState } from "react";
import axios from "axios";
import styles from "./ClientAdd.module.css";
import Spinner from "../Spinner/Spinner";
import Popup from "../Popup/Popup";
import { API } from "../../config";
import { useImageUpload } from "./hooks/useImageUpload";
import { useNavigate } from "react-router-dom";

function ClientAdd() {
  const navigate = useNavigate();
  const [order, setOrder] = useState();
  const [name, setName] = useState();
  const [logo, setLogo] = useState();
  const [value, setValue] = useState();
  const {
    selectedFile,
    imagePreview,
    uploadError,
    setUploadError,
    handleFileChange,
    uploadImage,
    resetImageState,
  } = useImageUpload();
  // const [cloud, setCloud] = useState(false);
  const [show, setShow] = useState(false);
  const [spin, setSpin] = useState(false);

  const change = () => {
    setShow(false);
  };

  const saveCloud = async (event) => {
    event.preventDefault();
    setUploadError("");

    // Validate required fields
    if (!name) {
      setUploadError("Company name is required");
      return;
    }

    if (!selectedFile) {
      setUploadError("Please select an image file");
      return;
    }

    window.scrollTo(0, 0);
    setSpin(true);

    try {
      // First, upload the image
      const uploadedImageUrl = await uploadImage(selectedFile);

      if (!uploadedImageUrl) {
        setUploadError("Failed to upload image. Please try again.");
        setSpin(false);
        return;
      }

      // Then save the data with the uploaded image URL
      await saveData(uploadedImageUrl);
    } catch (error) {
      console.error("Error in save process:", error);
      setUploadError("An error occurred. Please try again.");
      setSpin(false);
    }
  };

  const saveData = async (imageUrl) => {
    const data = {
      order_no: order,
      company_name: name,
      logo_url: imageUrl,
      value: value,
    };

    try {
      await axios.post(`${API}/companyList`, data);
      setShow(true);
      setSpin(false);
      // Reset form
      setName("");
      setOrder("");
      setValue("");
      resetImageState();
      setLogo("");
      navigate(-1);
    } catch (err) {
      console.error(err);
      setUploadError(
        err.response?.data?.message ||
          "Failed to save client logo. Please try again."
      );
      setSpin(false);
    }
  };

  return (
    <>
      {spin ? <Spinner /> : null}
      {show ? (
        <Popup show={show} switch={change} message="Added Successfully" />
      ) : null}
      <div className={styles.clientpage}>
        <div className={styles.heading}>
          <h1 className={styles.details}>Enter the Client Logo Details</h1>
          <form onSubmit={saveCloud}>
            <div className={styles.items}>
              <div className={styles.second}>
                <p>Enter the Company Name</p>
                <input
                  name="company_name"
                  placeholder="Category Name"
                  type="text"
                  onChange={(event) => setName(event.target.value)}
                  id={styles.gap}
                  required
                ></input>
              </div>

              <div className={styles.images}>
                <p>
                  Select Logo Image <span style={{ color: "red" }}>*</span>
                </p>
                <input
                  name="logo_file"
                  type="file"
                  accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                  onChange={handleFileChange}
                  id={styles.file}
                  required
                ></input>
                 <p
                  style={{
                    fontSize: "14px",
                    fontStyle: "italic",
                  }}
                >
                  Supported file types: JPEG, PNG, WebP
                </p>
                {uploadError && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    {uploadError}
                  </div>
                )}
                {imagePreview && (
                  <div style={{ marginTop: "12px" }}>
                    <img
                      src={imagePreview}
                      alt="Preview"
                      style={{
                        maxWidth: "200px",
                        maxHeight: "200px",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                    />
                  </div>
                )}
              </div>

              <div className={styles.button}>
                <input type="submit" className={styles.bttn} value="Submit" />
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* {
                cloud ? <Cloudflare logo={logo} setLogo={setLogo}></Cloudflare> : null
            } */}
    </>
  );
}

export default ClientAdd;
